/* AWA postcode checker (CLAUDE DRAFT). Uses a throwaway Storefront cart; the real cart is never touched. */
(function () {
  var RANGES = [['NT', 800, 999], ['ACT', 200, 299], ['NSW', 1000, 2599], ['ACT', 2600, 2618], ['NSW', 2619, 2899], ['ACT', 2900, 2920], ['NSW', 2921, 2999],
    ['VIC', 3000, 3999], ['QLD', 4000, 4999], ['SA', 5000, 5999], ['WA', 6000, 6999], ['TAS', 7000, 7999], ['VIC', 8000, 8999], ['QLD', 9000, 9999]];
  function stateOf(pc) { var n = parseInt(pc, 10); for (var i = 0; i < RANGES.length; i++) if (n >= RANGES[i][1] && n <= RANGES[i][2]) return RANGES[i][0]; return ''; }
  function money(a) { var n = Number(a); return n === 0 ? 'Free' : '$' + n.toFixed(2).replace(/\.00$/, ''); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function place(box) {
    // 1) Above the installation builder (it always follows Add to cart).
    var builder = Array.prototype.slice.call(document.querySelectorAll('awa-installation2, awa-system-installation-card, .awa-system-installation-card, [class*="awa-hws-installation"]'))
      .filter(function (b) { return !b.closest('.awa-dc') && !b.parentElement.closest('awa-installation2, .awa-system-installation-card, [class*="awa-hws-installation"]'); })[0];
    if (builder) { builder.parentNode.insertBefore(box, builder); box.classList.add('is-placed'); return; }
    // 2) Otherwise right after the main Add to cart block.
    var btn = Array.prototype.slice.call(document.querySelectorAll('button[name="add"], button[type="submit"][name="add"], [name="add"]'))
      .filter(function (b) { return !b.closest('[id*="sticky"], [class*="sticky"], quick-view, .side-panel, .awa-dc'); })[0];
    var title = document.querySelector('h1');
    if (!btn || !title) return;
    var el = btn;
    while (el.parentElement && !el.parentElement.contains(title)) el = el.parentElement;
    if (!el.parentElement) return;
    el.parentNode.insertBefore(box, el.nextSibling);
    box.classList.add('is-placed');
  }
  function currentVariant(box) {
    var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return (f && f.value) || box.dataset.variantId;
  }

  function gql(cfg, query, variables) {
    return fetch('/api/' + cfg.apiVersion + '/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg.token }, body: JSON.stringify({ query: query, variables: variables }) })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) { if (j.errors && j.errors.length) throw new Error(j.errors[0].message); return j.data; });
  }
  // ---- Freight rules (mirror the AWA Freight Engine; edited in the theme editor) ----
  function lines(t) { return String(t || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(function (l) { return l && l.charAt(0) !== '#'; }); }
  function parseZones(t) {
    var z = {};
    lines(t).forEach(function (l) {
      var p = l.split('|').map(function (x) { return x.trim(); }); if (p.length < 3) return;
      z[p[0].toLowerCase()] = { name: p[1], ranges: p[2].split(',').map(function (r) { var m = r.trim().split('-'); return [parseInt(m[0], 10), parseInt(m[1] || m[0], 10)]; }) };
    });
    return z;
  }
  function inZone(z, pc) { var n = parseInt(pc, 10); return z.ranges.some(function (r) { return n >= r[0] && n <= r[1]; }); }
  function freight(cfg, pc) {
    var tags = (cfg.tags || []).map(function (t) { return String(t).toLowerCase().trim(); });
    var zones = parseZones(cfg.zones), rule = null;
    lines(cfg.rules).some(function (l) {
      var p = l.split('|').map(function (x) { return x.trim(); });
      if (p[0] && tags.indexOf(p[0].toLowerCase()) > -1) { rule = { zones: (p[1] || 'all').toLowerCase(), price: p[2] || '', pickup: (p[3] || '').toUpperCase() }; return true; }
    });
    if (!rule) return { kind: 'none' }; // no freight tag = the freight app doesn't deliver it (pickup or quote only)
    if (rule.zones === 'all') return { kind: 'all', price: rule.price, pickup: rule.pickup };
    var names = [], hit = null;
    rule.zones.split(',').forEach(function (k) { var z = zones[k.trim()]; if (!z) return; names.push(z.name); if (!hit && inZone(z, pc)) hit = z; });
    return hit ? { kind: 'zone', zone: hit.name, price: rule.price, pickup: rule.pickup } : { kind: 'out', names: names, pickup: rule.pickup };
  }
  // Pickup locations that stock THIS variant.
  var Q_PICKUP = 'query($id: ID!){node(id:$id){... on ProductVariant{storeAvailability(first:20){nodes{available pickUpTime location{name address{city provinceCode zip}}}}}}}';
  function pickupCheck(cfg, variantId) {
    return gql(cfg, Q_PICKUP, { id: 'gid://shopify/ProductVariant/' + variantId }).then(function (d) {
      var nodes = (d && d.node && d.node.storeAvailability && d.node.storeAvailability.nodes) || [];
      // Pickup follows Shopify's fulfilment locations only: wherever the product is stocked for pickup.
      return nodes.filter(function (n) { return n.available && n.location; });
    });
  }
  // ---- One postcode for everything: hand the postcode to the installation checks on the page ----
  var STATE_NAMES = { WA: 'western australia', NSW: 'new south wales', VIC: 'victoria', QLD: 'queensland', SA: 'south australia', TAS: 'tasmania', ACT: 'australian capital territory', NT: 'northern territory' };
  var INSTALL_FORMS = '[data-awa-installation-form], .awa-system-installation-card__form';
  function installInputs() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-awa-installation-postcode], .awa-system-installation-card__form input[type="text"], .awa-system-installation-card__form input:not([type])'))
      .filter(function (i) { return !i.closest('.awa-dc'); });
  }
  function setState(st) {
    document.querySelectorAll('awa-installation2 select, [class*="awa-hws-installation"] select, .awa-system-installation-card select').forEach(function (sel) {
      var opts = Array.prototype.slice.call(sel.options), want = STATE_NAMES[st];
      if (!want || !opts.some(function (o) { return (o.text || '').toLowerCase().indexOf('australia') > -1 || /^(wa|nsw|vic|qld|sa|tas|act|nt)$/i.test(o.value); })) return;
      var hit = opts.filter(function (o) { var t = (o.text || '').trim().toLowerCase(), v = (o.value || '').trim().toLowerCase(); return t === want || v === want || v === st.toLowerCase() || t === st.toLowerCase(); })[0];
      if (hit && sel.value !== hit.value) { sel.value = hit.value; sel.dispatchEvent(new Event('input', { bubbles: true })); sel.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }
  function syncInstall(pc, st) {
    setState(st);
    installInputs().forEach(function (inp) {
      inp.value = pc;
      inp.dispatchEvent(new Event('input', { bubbles: true }));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      var f = inp.closest(INSTALL_FORMS) || inp.form;
      // Synthetic submit: runs the builder's check, never reloads.
      if (f) f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }
  // Installation postcode/state come from the Postcode checker; the real field stays hidden so the builder still works.
  var PC_LINES = [];
  function renderLines(pc, st) {
    PC_LINES.forEach(function (l) {
      l.textContent = '';
      if (pc) {
        l.appendChild(document.createTextNode('Installation postcode: '));
        var b = el('strong', 'awa-dc-pcline__pc', pc + (st ? ' ' + st : '')); l.appendChild(b);
        l.appendChild(document.createTextNode(' · '));
        var a = el('a', 'awa-dc-pcline__link', 'Change postcode'); a.href = '#'; a.addEventListener('click', l._go); l.appendChild(a);
      } else {
        l.appendChild(document.createTextNode('Enter your postcode in the '));
        var a2 = el('a', 'awa-dc-pcline__link', 'Postcode checker'); a2.href = '#'; a2.addEventListener('click', l._go); l.appendChild(a2);
        l.appendChild(document.createTextNode(' above.'));
      }
    });
  }
  function lockInstall(mainInput) {
    function goToChecker(e) { if (e) e.preventDefault(); mainInput.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { mainInput.focus(); }, 350); }
    installInputs().forEach(function (inp) {
      if (inp.dataset.awaLocked) return; inp.dataset.awaLocked = '1';
      inp.readOnly = true; inp.tabIndex = -1;
      var f = inp.closest(INSTALL_FORMS) || inp.form;
      var line = el('p', 'awa-dc-pcline'); line._go = goToChecker;
      line.style.cssText = 'margin:4px 0 0;font-size:14px;line-height:1.5;color:var(--color-body,#2c2d2e)';
      if (f) { f.style.display = 'none'; f.parentNode.insertBefore(line, f); }
      else { inp.style.display = 'none'; inp.parentNode.insertBefore(line, inp); }
      PC_LINES.push(line);
    });
    document.querySelectorAll('awa-installation2 select, [class*="awa-hws-installation"] select, .awa-system-installation-card select').forEach(function (sel) {
      if (!Array.prototype.some.call(sel.options, function (o) { return (o.text || '').toLowerCase().indexOf('australia') > -1; })) return;
      sel.tabIndex = -1; sel.setAttribute('aria-readonly', 'true');
      sel.style.pointerEvents = 'none'; sel.style.background = '#f5f7fa';
    });
    var existing = (installInputs()[0] || {}).value || '';
    renderLines(/^\d{4}$/.test(existing) ? existing : '', /^\d{4}$/.test(existing) ? stateOf(existing) : '');
  }
  function init(box) {
    if (box.dataset.ready) return; box.dataset.ready = '1';
    var cfg = {}; try { cfg = JSON.parse(box.querySelector('[data-awa-dc-config]').textContent); } catch (e) {}
    place(box);
    var form = box.querySelector('[data-awa-dc-form]'), input = box.querySelector('[data-awa-dc-postcode]');
    var results = box.querySelector('[data-awa-dc-results]'), del = box.querySelector('[data-awa-dc-delivery]'), pick = box.querySelector('[data-awa-dc-pickup]');
    var btn = form.querySelector('button');
    function show(node, cls, title, text) { node.className = 'awa-dc__result ' + cls; node.textContent = ''; node.appendChild(el('strong', '', title)); if (text) node.appendChild(el('span', '', text)); }
    function pickup(st) {
      var p = (cfg.pickups || []).filter(function (x) { return x.state === st || (st === 'ACT' && x.state === 'NSW'); })[0];
      if (p) show(pick, 'awa-dc__result--pickup', 'Free pickup', p.name + ' · ' + p.ready);
      else show(pick, 'awa-dc__result--pickup', 'Pickup', 'Our pickup points are in WA, SA, VIC and NSW.');
    }
    input.addEventListener('input', function () { this.value = this.value.replace(/\D/g, '').slice(0, 4); });
    var syncing = false;
    // Pre-fill from any existing installation postcode, then lock.
    installInputs().forEach(function (inp) { if (!input.value && /^\d{4}$/.test((inp.value || '').trim())) input.value = inp.value.trim(); });
    lockInstall(input);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var pc = input.value, st = stateOf(pc);
      results.hidden = false;
      if (!/^\d{4}$/.test(pc) || !st) { show(del, 'is-error', 'Check the postcode', 'Please enter a 4-digit Australian postcode.'); pick.hidden = true; return; }
      pick.hidden = false;
      syncing = true; try { syncInstall(pc, st); renderLines(pc, st); } catch (er) {} syncing = false;
      show(del, 'is-loading', 'Checking delivery to ' + pc + '\u2026', ''); show(pick, 'is-loading awa-dc__result--pickup', 'Checking pickup…', ''); btn.disabled = true;
      var variantId = currentVariant(box), canPickupHere = null;
      var pickupDone = (!cfg.token || !window.fetch ? Promise.reject() : pickupCheck(cfg, variantId)).then(function (avail) {
        var here = avail.filter(function (n) { var p = n.location.address && n.location.address.provinceCode; return p === st || (st === 'ACT' && p === 'NSW'); })[0];
        canPickupHere = !!here;
        if (here) show(pick, 'is-ok awa-dc__result--pickup', 'Free pickup', here.location.name + (here.pickUpTime ? ' · ' + here.pickUpTime.charAt(0).toLowerCase() + here.pickUpTime.slice(1) : ''));
        else if (avail.length) show(pick, 'is-warn awa-dc__result--pickup', 'No pickup in ' + st + ' for this product', 'Pickup only from ' + avail.map(function (n) { return n.location.name; }).join(', ') + '.');
        else show(pick, 'is-warn awa-dc__result--pickup', 'Not available for pickup', 'This product can’t be collected from our pickup points.');
      }).catch(function () { pickup(st); });
      var f = freight(cfg, pc);
      pickupDone.then(function () {
        if (f.kind === 'zone') show(del, 'is-ok', '\u2713 Delivery available to ' + pc + ' ' + st, (f.price ? f.price + ' \u00b7 ' : '') + f.zone + '. Exact cost confirmed at checkout.');
        else if (f.kind === 'all') show(del, 'is-ok', '\u2713 Delivery available to ' + pc + ' ' + st, (f.price ? f.price + ' \u00b7 ' : '') + 'Delivered Australia-wide. Exact cost confirmed at checkout.');
        else if (f.kind === 'out') show(del, 'is-warn', 'No delivery to ' + pc + ' for this product', 'Delivered to ' + f.names.join(', ') + ' only.' + (canPickupHere ? ' You can collect it instead.' : ' Contact us and we\u2019ll check other options.'));
        else show(del, 'is-warn', 'Not delivered', 'This product is pickup or quote only.' + (canPickupHere ? ' You can collect it below.' : ' Contact us for a freight quote.'));
        btn.disabled = false;
      });
    });
  }
  function boot() { document.querySelectorAll('[data-awa-dc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.AWADeliveryChecker = { stateOf: stateOf };
})();
